export const TaskApprovalEnum = {
    WaitApproval: 1, // Chờ phê duyệt
    Approved: 2, // Đã phê duyệt
    Reject: 3, // Từ chối
    Revoke: 4 // Đã thu hồi
  };